import React from 'react';
import { SideBySideMagnifier } from 'react-image-magnifiers';
import { ImageItemWrapper } from './Styled';
import { cloudflareLoader } from '~/shared/components/Image/loaders/cloudflareLoader';
import { Image } from '~/features/product-details-page/pdp.definitions';

type Props = {
    images?: Image[];
    onClick: (index: number) => void;
};

export const ImageItems = ({ images, onClick }: Props) => {
    if (!images) {
        return null;
    }

    function handleClick(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        const index = event.currentTarget.getAttribute('data-index');

        if (onClick && index) {
            onClick(Number(index));
        }
    }

    return (
        <>
            {images.map((image, index) => (
                <ImageItemWrapper key={image.src} data-index={index} onClick={handleClick}>
                    <SideBySideMagnifier
                        alwaysInPlace
                        imageAlt={image.alt}
                        imageSrc={cloudflareLoader({
                            src: image.src,
                            width: 600 * (images.length === 1 ? 2 : 1),
                        })}
                        largeImageSrc={cloudflareLoader({
                            src: image.src,
                            width: 1000 * (images.length === 1 ? 2 : 1),
                        })}
                    />
                </ImageItemWrapper>
            ))}
        </>
    );
};
